import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { PessoaItem } from "../typings";

function usePessoas(tenantId?: string | null, params?: any, onSuccess?: (data: PaginateResult<PessoaItem>) => any) {
  return useQuery([`/v1/pessoas?tenant=${tenantId}`, params], async () => {
    
    const { data } = await axios.get<PaginateResult<PessoaItem>>(
      `/v1/pessoas`,
      {
        params: {
          tenantId,
          ...(params ?? {}),
        },
      }
    );

    return data;
  }, {
    onSuccess,
  });
}

export default usePessoas;
